import { IUpdateRequisicaoCompraUseCase } from "../../../presentation/useCases/update/update_requisicao_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * UpdateRequisicaoCompraUseCase
 */

export class UpdateRequisicaoCompraUseCase implements IUpdateRequisicaoCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async updateRequisicaoCompra(
    idRequisicaoCompra: number,
    status: number,
    aprovadoPor: number | null,
    dataAprovadoPor: Date | null,
    dataCadastro: Date,
    solicitante: number | null,
    dataRequisicao: Date | undefined,
    centroCusto: number | null,
    dataPrevistaUtilizacao: Date | undefined,
    descricao: string | null,
    observacao: string | null,
    arquivo1: File | undefined,
    limparArquivo1: boolean,
    arquivo2: File | undefined,
    limparArquivo2: boolean,
  ): Promise<void> {
    await this.repository.updateRequisicaoCompra(
      idRequisicaoCompra,
      status,
      aprovadoPor,
      dataAprovadoPor,
      dataCadastro,
      solicitante,
      dataRequisicao ?? null,
      centroCusto,
      dataPrevistaUtilizacao ?? null,
      descricao,
      observacao,
      arquivo1 ?? null,
      limparArquivo1,
      arquivo2 ?? null,
      limparArquivo2,
    );
  }
}
